var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H2V16H5V9Z",
    fill: "#BFC0C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9H8.5V16H11.5V9Z",
    fill: "#BFC0C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H0V21H20V18Z",
    fill: "#BFC0C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H15V16H18V9Z",
    fill: "#BFC0C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 5V7H20V5L10 0Z",
    fill: "#BFC0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.b5d263217b389307414cf2633c83fae7.svg";
export { ForwardRef as ReactComponent };